import { Icon, CheckedIcon, IndeterminateIcon } from "./CheckboxIcons";
export const MuiCheckbox = {
    defaultProps: {
        icon: Icon,
        checkedIcon: CheckedIcon,
        indeterminateIcon: IndeterminateIcon
    },
    styleOverrides: {
        sizeSmall: {
            width: "38px",
            height: "38px",
            //we assume the icon is a svg element.
            "& > svg": {
                fontSize: "15px"
            }
        },
        sizeMedium: {
            width: "42px",
            height: "42px",
            //we assume the icon is a svg element.
            "& > svg": {
                fontSize: "18px"
            }
        }
    }
};
//# sourceMappingURL=Checkbox.js.map